import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSpinLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M17.104 17.151a.75.75 0 0 1-1.5 0v-.514c-.611.584-1.389 1.044-2.167 1.375-1.46.62-3.194.913-4.538.678-2.43-.424-4.042-1.362-4.674-1.993a.75.75 0 1 1 1.059-1.062c.355.356 1.652 1.19 3.873 1.577.983.171 2.418-.04 3.693-.581.899-.382 1.592-.873 2.005-1.392l-1.13.216a.75.75 0 0 1-.282-1.474l2.77-.529.89-.17zM10 6.527a3.49 3.49 0 0 1 0 6.98l-.18-.005A3.49 3.49 0 0 1 10 6.527m0 1.5a1.99 1.99 0 1 0 0 3.981 1.99 1.99 0 0 0 0-3.98M6.58 2.022c1.46-.62 3.194-.913 4.537-.678 2.432.424 4.042 1.362 4.675 1.993a.75.75 0 0 1-1.059 1.061c-.356-.355-1.652-1.188-3.874-1.576-.983-.171-2.418.04-3.692.581-.899.382-1.592.873-2.005 1.392l1.13-.216a.75.75 0 0 1 .281 1.474l-2.77.529-.89.17v-3.87a.75.75 0 0 1 1.5 0v.515c.61-.584 1.388-1.044 2.167-1.375"
            />
        </svg>
    );
}
export default memo(IconArrowSpinLeft20);
